/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.drawsParticipations.internal

import features.drawsParticipations.models.ParticipationsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class DrawsParticipationsServiceImpl : DrawsParticipationsService {

    private val drawsParticipationsRequest = DrawsParticipationsRequest()

    override suspend fun getDrawsParticipations(
        overrideHeaders : Map<String, String>?,
    ): Result<ParticipationsModel> {
        return drawsParticipationsRequest.getDrawsParticipations(
            overrideHeaders = overrideHeaders,
        ).toModel()
    }
}
